<!--
  应用默认布局。
  负责全局顶部导航、用户菜单和页面主体容器，所有普通页面都会套用这里。
-->
<template>
  <div class="app-layout">
    <!-- 全局头部导航 -->
    <header class="global-header">
      <div class="header-left">
        <div class="brand-block">
          <h2 class="logo">🤖 {{ APP_BRAND.PRODUCT_NAME }}</h2>
          <p class="tagline">{{ APP_BRAND.SLOGAN }}</p>
        </div>
        <!-- 全局导航菜单 -->
        <nav class="nav-menu">
          <NuxtLink to="/" class="nav-item" active-class="active">
            <el-icon>
              <ChatDotRound />
            </el-icon>
            <span>聊天</span>
          </NuxtLink>
          <NuxtLink to="/stats" class="nav-item" active-class="active">
            <el-icon>
              <DataBoard />
            </el-icon>
            <span>统计</span>
          </NuxtLink>
          <NuxtLink to="/memory" class="nav-item" active-class="active">
            <el-icon>
              <Collection />
            </el-icon>
            <span>记忆</span>
          </NuxtLink>
          <NuxtLink to="/rag" class="nav-item" active-class="active">
            <el-icon>
              <Document />
            </el-icon>
            <span>文档问答</span>
          </NuxtLink>
          <NuxtLink to="/about" class="nav-item" active-class="active">
            <el-icon>
              <InfoFilled />
            </el-icon>
            <span>关于</span>
          </NuxtLink>
          <NuxtLink to="/resume" class="nav-item" active-class="active">
            <el-icon>
              <Female />
            </el-icon>
            <span>简历</span>
          </NuxtLink>
        </nav>
      </div>
      <div class="header-right">
        <slot name="header-actions" />
        <AuthMenu />
      </div>
    </header>

    <!-- 页面主要内容 -->
    <main class="main-content">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
import { ChatDotRound, Collection, DataBoard, Document, Female, InfoFilled } from '@element-plus/icons-vue'
import AuthMenu from '~/components/AuthMenu.vue'
import { APP_BRAND } from '~/enums'
</script>

<style scoped lang="scss">
.app-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.global-header {
  padding: 16px 24px;
  background: white;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  .header-left {
    display: flex;
    align-items: center;
    gap: 32px;
  }

  .brand-block {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 220px;
  }

  .logo {
    margin: 0;
    font-size: 24px;
    color: #303133;
    font-weight: 600;
  }

  .tagline {
    margin: 0;
    color: #909399;
    font-size: 12px;
    line-height: 1.2;
    white-space: nowrap;
  }

  .nav-menu {
    display: flex;
    gap: 8px;

    .nav-item {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 8px 16px;
      border-radius: 8px;
      color: #606266;
      text-decoration: none;
      transition: all 0.3s;
      font-size: 14px;

      &:hover {
        background: #f0f2f5;
        color: #409eff;
      }

      &.active {
        background: #ecf5ff;
        color: #409eff;
        font-weight: 500;
      }

      .el-icon {
        font-size: 16px;
      }
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }
}

.main-content {
  flex: 1;
  height: calc(100vh - 68px);
}
</style>
